export default __webpack_public_path__ + "e1a09436ead80e2363d307b1b7777cfd.png";